import autocomplete from 'autocompleter'
import $ from 'jquery'

import '../../../scss/app/services.scss'

const keywordsField = document.querySelector('.js-keywords');
if (keywordsField) {
  const keywordAutocompleteValues =
    keywordsField.getAttribute('data-autocomplete').split(',').map((keyword) => {
      return { label: keyword, value: keyword }
    })
  autocomplete({
    input: keywordsField,
    disableAutoSelect: true,
    fetch: (text, update) => {
      if (text === '') {
        update(keywordAutocompleteValues)
        return
      }
      // eslint-disable-next-line no-param-reassign
      text = text.toLowerCase()
      const suggestions = keywordAutocompleteValues.filter((n) => n.label.toLowerCase().indexOf(text) !== -1)
      update(suggestions)
    },
    onSelect: (item) => {
      keywordsField.value = item.value
    },
  })
}

$('.service__file-play-button button').on('click', (ev) => {
  const $this = $(ev.currentTarget)
  const $playerContainers = $this.closest('.services').find('.service__file-player')
  const $playerContainer = $this.closest('.service__file').find('.service__file-player')
  const file = $this.attr('data-file')
  const soundCloudId = $this.attr('data-soundcloud-id')
  const soundCloudToken = $this.attr('data-soundcloud-token')

  $playerContainers.html('')

  if (file) {
    $playerContainer.html(`<audio src="${file}" controls autoplay></audio>`)
    $playerContainer.addClass('is-visible')
  } else if (soundCloudId) {
    $playerContainer.html(`
      <iframe width="100%" height="166" scrolling="no" frameBorder="no"
        src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/${soundCloudId}%3Fsecret_token%3D${soundCloudToken}&amp;color=00aabb&amp;auto_play=true&amp;hide_related=true&amp;show_comments=false&amp;show_user=false&amp;show_artwork=false&amp;show_reposts=false&amp;show_playcount=false&amp;download=false"></iframe>
    `)
    $playerContainer.addClass('is-visible')
  }
})
